/**
 * Prefix the given key with the budgets v2 module path segments.
 */
export const getApiKey = (key: unknown[] = []) => [
  'v2',
  'budgets',
  'definitions',
  ...key,
];
